const AsyncDocumentJobStatus = {
  PENDING: "PENDING",
  IN_PROCESSING: "IN_PROCESSING",
  SUCCESS: "SUCCESS",
  PARTIAL_SUCCESS: "PARTIAL_SUCCESS",
  FAILURE: "FAILURE",
  TIMEOUT: "TIMEOUT",
  VALIDATION_ERROR: "VALIDATION_ERROR",
  GENERATE_S3_KEY_FAILED: "GENERATE_S3_KEY_FAILED",
  INTERNAL_DOCUMENT_DOWNLOAD_FAILED: "INTERNAL_DOCUMENT_DOWNLOAD_FAILED",
  CONCATENATION_FAILED: "CONCATENATION_FAILED",
  UPDATE_LABELS_STATUS_FAILED: "UPDATE_LABELS_STATUS_FAILED",
} as const;

type AsyncDocumentJobStatus =
  typeof AsyncDocumentJobStatus[keyof typeof AsyncDocumentJobStatus];

export default AsyncDocumentJobStatus;
